import { useState, useEffect } from 'react';
import { CustomTooltip, Loader } from 'components';

import * as S from './TransactionTable.styled';

const TABLE_ROW_INITIAL_COUNT = 7;
const TABLE_ROW_INCREMENT = 5;

export const TransactionsTable = ({ filteredData, isFetching, isError }) => {
  const totalRows = filteredData?.length;
  const [visibleRows, setVisibleRows] = useState(
    totalRows ? Math.min(TABLE_ROW_INITIAL_COUNT, totalRows) : 0,
  );

  useEffect(() => {
    setVisibleRows(totalRows ? Math.min(TABLE_ROW_INITIAL_COUNT, totalRows) : 0);
  }, [totalRows, isFetching]);

  function handleLoadMore() {
    setVisibleRows((state) => {
      if (state + TABLE_ROW_INCREMENT < totalRows) return state + TABLE_ROW_INCREMENT;
      if (state === totalRows) return state;
      return totalRows;
    });
  }

  if (isError) {
    return <h2 style={{ border: '1px solid red', color: 'red', textAlign: 'center' }}>Error</h2>;
  }

  if (isFetching) {
    return (
      <S.LoaderBox>
        <Loader.Local delay={20} />
      </S.LoaderBox>
    );
  }

  if (!totalRows) {
    return <S.NoDataWrap>No records to display</S.NoDataWrap>;
  }

  return (
    <div>
      <S.Table>
        <S.TableHead>
          <div>Date</div>
          <div>Payment</div>
          <div>Type</div>
          <div>Payment Method</div>
          <div>Previous Balance</div>
          <div>Balance</div>
          <div>Transaction ID</div>
        </S.TableHead>
        {filteredData?.slice(0, visibleRows)?.map((item, ind) => (
          <S.TableRow key={item.transactionId + ind}>
            <S.TextBolder>{item.transactionDate}</S.TextBolder>
            <S.TextBolder
              color={
                item.paymentType === 'Charge' && item.payment >= 0
                  ? 'green'
                  : item.paymentType === 'Credit' || item.payment < 0
                  ? 'red'
                  : ''
              }
            >
              {item.payment < 0 && '('}${+Math.abs(item.payment).toFixed(3)}
              {item.payment < 0 && ')'}
            </S.TextBolder>
            <S.Text>{item.paymentType}</S.Text>
            <S.Text>{item.paymentMethod}</S.Text>
            <S.Text color={item.previousBalance < 0 ? 'red' : ''}>
              {item.previousBalance < 0 && '('}${+Math.abs(item.previousBalance).toFixed(3)}
              {item.previousBalance < 0 && ')'}
            </S.Text>
            <S.Text color={item.balance < 0 ? 'red' : ''}>
              {item.balance < 0 && '('}${+Math.abs(item.balance).toFixed(3)}
              {item.balance < 0 && ')'}
            </S.Text>
            <CustomTooltip
              content={<S.Text>{item.transactionId}</S.Text>}
              text={<p>{item.transactionId}</p>}
            />
          </S.TableRow>
        ))}
      </S.Table>
      <S.TableFooter>
        <S.FooterBtn isActive={visibleRows < totalRows} onClick={handleLoadMore}>
          Load More
        </S.FooterBtn>
        <S.FooterBody>
          <p>
            Showed: <span>{visibleRows}</span> of <span>{totalRows}</span>
          </p>
          <S.ProgressBar status={(visibleRows / totalRows) * 100}></S.ProgressBar>
        </S.FooterBody>
      </S.TableFooter>
    </div>
  );
};
